module.exports = __webpack_public_path__ + "static/img/list-project.a6586ce.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/common/img/list-project.jpg
// module id = ZAe+
// module chunks = 1